<template>
  <div v-show="active">
    <div class="row">
      <div class="col">
        <div v-if="$store.state.debug.navigation">{{ sectionContent.sectionOrdinal }}: {{ sectionContent.hspSectionId }}</div>
        <div v-if="sectionContent.sectionTitle"><h2>{{ sectionContent.sectionTitle }}</h2></div>
        <div v-if="sectionContent.sectionHeader" v-html="sectionContent.sectionHeader" class="mb-3"></div>
        <div v-for="category in sectionContent.categories" :key="category.hspCategoryId">
          <section-category
            :category="category"
            :questionNumbers="questionNumbers"
            :validateImmediate="validateImmediate"
            :missingResponseSection="missingResponseSection"
            :isDarkMode="isDarkMode"
            @putSectionResponses="putSectionResponses"
            @triggercleared="setSectionTrigger"></section-category>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-6 col-md-3">
        <base-button :type="colorScheme" :block="true" @click="$emit('nav', 'previous', categoryQuestionIds)" :disabled="isFirstSection">Previous</base-button>
      </div>
      <div class="col-6 col-md-3">
        <base-button :type="colorScheme" :block="true" @click="$emit('nav', 'next', categoryQuestionIds)">
          <span v-if="!isLastSection || (missingResponseSection && missingResponseSection.hspSectionId !== sectionContent.hspSectionId)">Next</span>
          <span v-else>Finish</span>
        </base-button>
      </div>
    </div>
    <div class="row justify-content-center mt-3 mb-0">
      <div class="col col-md-10">
        <slot></slot>
      </div>
    </div>
    <div v-if="sectionContent.sectionFooter" v-html="sectionContent.sectionFooter" class="mb-3"></div>
  </div>
</template>
<script>
import SectionCategory from './Category';
import { mapGetters } from 'vuex';

export default {
  components: {
    SectionCategory
  },
  props: {
    sectionContent: Object,
    active: Boolean,
    missingResponseSection: Object,
    invalidate: Boolean,
    isDarkMode: Boolean,
  },
  data() {
    return {
      questionNumbers: {},
      categoryQuestionIds: [],
      sectionTrigger: [],
      validateImmediate: false,
    }
  },
  computed: {
    ...mapGetters([
      'colorScheme',
      'isFirstSection',
      'isLastSection',
      'getSectionResponseTriggers'
    ])
  },
  methods: {
    setSectionTrigger() {
      if(this.sectionTrigger) {
        this.$store.dispatch('setTargetSection', this.sectionTrigger);
      }
    },
    setTriggers() {
      this.sectionContent.responseTriggers.forEach(trigger => {
        let payload = {}

        if(trigger.triggerCategoryQuestionId !== null) {
          let userResponse = this.$store.state
            .surveyUser
            .responses
            .find(response =>
              response.hspCategoryQuestionId === trigger.triggerCategoryQuestionId &&
              response.hspResponseId === trigger.triggerResponseId);

          if(userResponse) {
            payload.triggerSectionId = trigger.triggerSectionId;
            payload.targetSectionId = trigger.targetSectionId;
            this.$store.dispatch('setTargetSection', payload);
          }
        }
      });
    },
    putSectionResponses(categoryQuestionIds = this.categoryQuestionIds, isAsync = true) {
      if (!categoryQuestionIds || categoryQuestionIds.length === 0) {
        return;
      }

      this.$emit('putSectionResponses', categoryQuestionIds, isAsync);
    },
  },
  created: function() {
    let qCount = 0;

    this.sectionTrigger = this.$store.getters.getSectionResponseTriggers(this.sectionContent.hspSectionId)[0];
    this.setTriggers();

    if(this.active) {
      this.setSectionTrigger();
    }

    this.sectionContent.categories.forEach(category => {
      category.categoryQuestions.forEach(question => {
        let qNum = 0;

        // Ignore numbering if hspQuestionTypeId equals 5 (No Response Group), or the questionOrdinal is a negative number or zero
        if(question.hspQuestionTypeId === 5 || question.questionOrdinal <= 0) {
          qNum = 0;
        }
        else {
          qNum = ++qCount;
        }

        this.questionNumbers[question.hspCategoryQuestionId] = qNum;
        this.categoryQuestionIds.push(question.hspCategoryQuestionId);
      });
    });

    this.$store.dispatch('setNavSectionQuestionIds', {
      id: this.sectionContent.hspSectionId,
      questionIds: this.categoryQuestionIds
    });
  },
  watch: {
    active: function(value) {
      if(value === true) {
        this.setSectionTrigger();
      }
    },
    invalidate: function (newValue, oldValue) {
      this.validateImmediate = false;
      if (!newValue) {
        return;
      }

      if (!this.active) {
        return;
      }

      // Trigger an immediate validate to the validation-provider if this is the active section.
      this.validateImmediate = true;
    }
  }
}
</script>
